import eventBus from '@/services/eventBus'
import { IAlarmSituation } from '../alarmSituations.types.ts'

const created = (item: IAlarmSituation) => {
  eventBus.pub('alarmSituations.created', item)
}

const updated = (item: IAlarmSituation) => {
  eventBus.pub('alarmSituations.updated', item)
}

const deleted = (id: IAlarmSituation['id']) => {
  eventBus.pub('alarmSituations.deleted', id)
}

const alarmSituationsEvents = { created, updated, deleted }
export default alarmSituationsEvents
